import React from 'react';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Message from 'components/parts/message';
import ItemDetail from 'components/parts/item/itemDetail';
import { getProgramSetting } from 'actions/programSettingAction';
import { setBreadcrumb } from 'actions/breadcrumbAction';
import { clearMessage, setMessage} from 'actions/messageAction';
import { consoleLogger } from 'helpers';
import { convertTimestampToDate } from 'helpers';
import { lang } from 'lang';

/**
 * 調整プログラム詳細画面
 */
const SrvProgramDetail = (props) => {
  const { msg, error } = lang;
  const { id } = props.match.params;
  // リクエストキャンセルトークンを取得
  const cancelToken = axios.CancelToken.source();
  // グローバルステートから対象の調整プログラム設定を取り出す
  const programSettingState = useSelector(
    (state) => state.programSetting.items.filter((item) => item.product_cd === id)
  );
  const dispatch = useDispatch();
  // ブラウザでコンポーネントが初めて表示される時だけ実行される(≒componentDidMount)
  React.useEffect(() => {
    // メッセージの変数初期化
    dispatch(clearMessage());
    // パンくずリストにプロダクトコードをセット
    dispatch(setBreadcrumb(id));
    // 対象の調整プログラム設定を取得する
    if (programSettingState.length === 0) {
      getData(id, cancelToken);
    } else {
      dispatch(clearMessage());      
    }
    return () => { cancelToken.cancel('unmounted component.'); };
  }, []);

  // 対象の調整プログラム設定を取得する
  const getData = async (id, cancelToken) => {
    try {
      await dispatch(
        await getProgramSetting(id, cancelToken)
      ).then((result) => {
        if (result.status !== 200) {
          if (result.status === 404 && result.errcode === 'ITEM_NOT_FOUND') {
            dispatch(setMessage('info', msg.custom_file.not_exist));
          } else {
            dispatch(setMessage('danger', error.custom_file.get + `\n${result.errcode}`));
          }
        }
      });
    } catch (e) {
      consoleLogger('Fail get program setting detail.', e);
    }
  };
  // 調整プログラムがない場合
  if (programSettingState.length === 0) {
    return <div className="col-10 pt-3 pb-3"><Message/></div>;
  } else {
    return (
      <>
        <div className="col-10 pt-3 pb-3">
          <ItemDetail 
            title='Detail information' 
            labels={{
              product_cd: 'Product Code', 
              destination: 'Region', 
              model: 'Product name', 
              alias: 'Name',
              filename: 'File name without version',
              created_at: 'Upload date',
              updated_at: 'Last update',
            }}
            items={{
              ...programSettingState[0],
              created_at: convertTimestampToDate(programSettingState[0].created_at),
              updated_at: convertTimestampToDate(programSettingState[0].updated_at),
            }}
            operation={{ 
              edit: { path: `/srv/setting/edit/${programSettingState[0].product_cd}` },
            }}/> 
        </div>
      </>
    );
  }
};
SrvProgramDetail.propTypes = {
  match: PropTypes.object
};
SrvProgramDetail.defaultProps = {
  match: {
    params: {
      id: '',
    }
  }
};
export default SrvProgramDetail;
